import React, { Component } from 'react';
import { Modal, Glyphicon } from 'react-bootstrap';
import './App.css';
import './index.css';

export default class CreditsModal extends Component {

    constructor(props) {
        super(props);

        this.open = this.open.bind(this);
        this.close = this.close.bind(this);

        this.state = {
            showModal: false
        }
    }

    open() {
        this.props.hideNavBar();
        window.location.hash = "#credits";
    }

    close() {
        window.location.hash = "";
        this.setState({ showModal: false });
    }

    render() {
        return (
            <div className={this.props.giveClass} onClick={this.open}>Credits
                <Modal show={this.props.isCredits} onHide={this.close} className="filterModal">
                    <div id="filterModalHeader">
                        Credits
                        <Glyphicon glyph="remove" className="closeLocModal" onClick={this.close} />
                    </div>
                    <div className="creditsContent">
                        <h2>A Special Thanks To</h2>
                        <h3>Head Developers</h3>
                        <p>Erik Forkin</p>
                        <p>Levi Kipke</p>
                        <h3>Developers</h3>
                        <p>Chris Baldwin</p>
                        <p>Ian McKenzie</p>
                        <p>Patricia Huang</p>
                        <br />
                        <h5>Filter Icons Made By</h5>
                        <div className="iconCredits">
                            <p><a href="http://www.flaticon.com/authors/icomoon" title="Icomoon">Icomoon</a> from <a href="http://www.flaticon.com" title="Flaticon">www.flaticon.com</a></p>
                            <p><a href="http://www.freepik.com" title="Freepik">Freepik</a> from <a href="http://www.flaticon.com" title="Flaticon">www.flaticon.com</a></p>
                            <p><a href="http://www.flaticon.com/authors/popcorns-arts" title="Popcorns Arts">Popcorns Arts</a> from <a href="http://www.flaticon.com" title="Flaticon">www.flaticon.com</a></p>
                            <p><a href="http://www.flaticon.com/authors/madebyoliver" title="Madebyoliver">Madebyoliver</a> from <a href="http://www.flaticon.com" title="Flaticon">www.flaticon.com</a></p>
                            <p><a href="http://www.flaticon.com/authors/roundicons" title="Roundicons">Roundicons</a> from <a href="http://www.flaticon.com" title="Flaticon">www.flaticon.com</a></p>
                            <p><a href="http://www.flaticon.com/authors/dimi-kazak" title="Dimi Kazak">Dimi Kazak</a> from <a href="http://www.flaticon.com" title="Flaticon">www.flaticon.com</a></p>
                            <p><a href="http://www.flaticon.com/authors/vectors-market" title="Vectors Market">Vectors Market</a> from <a href="http://www.flaticon.com" title="Flaticon">www.flaticon.com</a></p>
                            <p><em>All are licensed by </em><a href="http://creativecommons.org/licenses/by/3.0/" title="Creative Commons BY 3.0" target="_blank"><em>CC 3.0 BY</em></a></p>
                        </div>
                    </div>
                </Modal>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/CreditsModal.js